/**
 * Búsqueda en el repertorio: sin distinguir mayúsculas ni tildes, y con todas las palabras de la
 * consulta presentes en alguno de los campos («quique pal» encuentra «Palomas en la quinta» de
 * «Quique González»).
 */
export function normalizeForSearch(text: string): string {
  return text.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase()
}

export function matchesQuery(fields: readonly string[], query: string): boolean {
  const words = normalizeForSearch(query).split(/\s+/).filter(Boolean)
  if (words.length === 0) return true
  const haystack = fields.map(normalizeForSearch).join(' ')
  return words.every((word) => haystack.includes(word))
}

export function filterByQuery<T>(
  items: readonly T[],
  query: string,
  fields: (item: T) => readonly string[],
): T[] {
  return items.filter((item) => matchesQuery(fields(item), query))
}

/** Orden alfabético en español, sin que las tildes ni las mayúsculas cambien el lugar. */
export function compareText(a: string, b: string): number {
  return normalizeForSearch(a).localeCompare(normalizeForSearch(b), 'es')
}
